import { queryOptions, useQuery } from '@tanstack/react-query';

import { Client } from '@/features/clients/models/client';
import { artiaProtectedApi } from '@/lib/api-client';
import { QueryConfig } from '@/lib/react-query';

export const clientsQueryKeys = {
  base: ['clients'] as const,
  all: () => [...clientsQueryKeys.base],
};

const getClients = async (): Promise<Client[]> => {
  return await artiaProtectedApi.get('clients');
};

export const clientsQueryOptions = () => {
  return queryOptions({
    queryKey: clientsQueryKeys.all(),
    queryFn: getClients,
  });
};

type UseClientsQueryOptions = {
  queryConfig?: QueryConfig<typeof clientsQueryOptions>;
};

export const useClientsQuery = ({ queryConfig }: UseClientsQueryOptions = {}) => {
  return useQuery({
    ...clientsQueryOptions(),
    ...queryConfig,
  });
};
